<template>
  <component
    :is="component"
    v-bind="$attrs"
    ref="drug"
  >

  </component>
</template>

<script>
import DrugUAE from './drugUAE.vue';
import DrugUS from './drugUS.vue';

export default {
  name: 'Drug',
  components: {DrugUAE, DrugUS},
  inheritAttrs: false,

  computed: {
    component() {
      return this.isUAE ? 'DrugUAE' : 'DrugUS';
    }
  },

  data() {
    return {
      isUAE: this.$store.state.companies.isUAE,
    }
  },

  beforeRouteLeave(to, from, next) {
        if (this.$refs.drug.pendingChanges) {
                this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                title: this.$t('Msg.Confirm'),
                okTitle: this.$t('Shared.BtnSave'),
                cancelTitle: this.$t('Shared.BtnDismiss'),
                footerClass: 'p-2',
                titleClass: 'modal-title modal-type-warning'
            })
            .then(async value => {
                if(!value){
                    next();
                } else {
                    await this.$refs.drug.SaveOrEdit();
                    next();
                }
            })		
        } else {
            next()
        }
    }
}
</script>